<div class="dialog">
    <div class="dialog-header">
        <h3 class="details-card-title">
            <ng-container *ngFor="let crumb of data.name; index as i">
                <icc-icon name="navigate_next" *ngIf="i > 0"></icc-icon>
                <span class="details-card-title__crumb">{{ crumb }}</span>
            </ng-container>
        </h3>
        <button
            iccIconButton
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>
    </div>
    <div class="dialog-body">
        <p *ngIf="valuationMode">{{ 'SALES_DOCUMENT|Składniki ceny:' | translate }}</p>
        <div class="table-wrapper" *ngIf="valuationMode">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th class="header-1">{{ 'SALES_DOCUMENT|Cena sprzedaży' | translate }}</th>
                        <th class="header-1">{{ 'SALES_DOCUMENT|Ilość' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let segment of priceSegments; trackBy: trackBySegmentId">
                        <tr *ngIf="segment.type !== 'market' && segment.type !== 'charge'">


                            <td class="row-header">
                                <span class="segment-type">{{ getSegmentType(segment) }}</span><br>
                                <span>{{ getSegmentName(segment) }}</span>
                            </td>
                            <td>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    *ngIf="data.isEditable"
                                    [ngModel]="segment.baseValue"
                                    (ngModelChange)="changeSegment(segment, 'baseValue', $event)"
                                    [ngModelOptions]="{updateOn: 'blur'}"
                                    inputmode="decimal"
                                >
                                <span *ngIf="data.isEditable && segment.valueType === 'value'">{{ currencySymbol }}</span>
                                <span *ngIf="data.isEditable && segment.valueType === 'percent'">%</span>
                                <span *ngIf="data.isEditable && segment.valueType === 'multiplier'">×</span>
                                <span *ngIf="!data.isEditable && segment.valueType === 'value'">
                                    {{ segment.baseValue | currency: data.currency }}
                                </span>
                                <span *ngIf="!data.isEditable && segment.valueType === 'percent'">
                                    {{ segment.baseValue / 100 | percent: '1.0-2' }}
                                </span>
                                <span *ngIf="!data.isEditable && segment.valueType === 'multiplier'">
                                    {{ segment.baseValue | number: '1.0-2' }}
                                </span>
                            </td>
                            <td>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    *ngIf="data.isEditable && segment.valueType === 'value'"
                                    [ngModel]="segment.quantity"
                                    (ngModelChange)="changeSegment(segment, 'quantity', $event)"
                                    [ngModelOptions]="{updateOn: 'blur'}"
                                    inputmode="decimal"
                                >
                                <span *ngIf="!data.isEditable && segment.valueType === 'value'">
                                    {{ segment.quantity }}
                                </span>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <p *ngIf="valuationMode && data.viewMode !== 'purchase'" class="info">{{ 'SALES_DOCUMENT|Wszystkie ceny zawierają narzut.' | translate }}</p>

        <p *ngIf="valuationMode">{{ 'SALES_DOCUMENT|Rabaty:' | translate }}</p>
        <div class="table-wrapper">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th colspan="3" *ngIf="data.saleView" class="header-1 header-1--sales">{{ 'SALES_DOCUMENT|Cena sprzedaży' | translate }}</th>
                        <th colspan="3" *ngIf="data.purchaseView" class="header-1 header-1--purchase">{{ 'SALES_DOCUMENT|Cena zakupu' | translate }}</th>
                    </tr>
                    <tr>
                        <th></th>
                        <th *ngIf="data.saleView && !position.priceIsGross" class="header-2">{{ 'SALES_DOCUMENT|Cena netto' | translate }}</th>
                        <th *ngIf="data.saleView && position.priceIsGross" class="header-2">{{ 'SALES_DOCUMENT|Cena brutto' | translate }}</th>
                        <th *ngIf="data.saleView" class="header-2">{{ 'SALES_DOCUMENT|Rabat' | translate }}</th>
                        <th *ngIf="data.saleView" class="header-2">{{ 'SALES_DOCUMENT|Cena z rabatem' | translate }}</th>
                        <th *ngIf="data.purchaseView && !buyPosition?.priceIsGross" class="header-2">{{ 'SALES_DOCUMENT|Cena netto' | translate }}</th>
                        <th *ngIf="data.purchaseView && buyPosition?.priceIsGross" class="header-2">{{ 'SALES_DOCUMENT|Cena brutto' | translate }}</th>
                        <th *ngIf="data.purchaseView" class="header-2">{{ 'SALES_DOCUMENT|Rabat' | translate }}</th>
                        <th *ngIf="data.purchaseView" class="header-2">{{ 'SALES_DOCUMENT|Cena z rabatem' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="position.type !== 'additional'">
                        <tr *ngFor="let discount of discounts; trackBy: trackByDiscountType">
                            <td class="row-header">{{ (discount.sales?.name || discount.buy?.name) | translate: { categoryName: discount.sales?.categoryName || discount.buy?.categoryName } }}</td>
                            <td *ngIf="data.saleView">{{ discount.sales?.price | currency: data.currency }}</td>
                            <td *ngIf="data.saleView">
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    *ngIf="data.isEditable && !hasOrderIntegration"
                                    [ngModel]="discount.sales?.value"
                                    (ngModelChange)="changeDiscount(discount.sales, 'value', $event)"
                                    [ngModelOptions]="{updateOn: 'blur'}"
                                    inputmode="decimal"
                                >
                                <span *ngIf="data.isEditable && !hasOrderIntegration">{{ currencySymbol }}</span>
                                <span *ngIf="data.isEditable && hasOrderIntegration">
                                    {{ discount.sales?.value | currency: data.currency }}
                                </span>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    *ngIf="data.isEditable"
                                    [ngModel]="discount.sales?.discount"
                                    (ngModelChange)="changeDiscount(discount.sales, 'percent', $event)"
                                    [ngModelOptions]="{updateOn: 'blur'}"
                                    inputmode="decimal"
                                >
                                <span *ngIf="data.isEditable">%</span>
                                <span *ngIf="!data.isEditable">
                                    {{ discount.sales?.value | currency: data.currency }} {{ discount.sales?.discount ? '(' + (discount.sales?.discount / 100 | percent: '1.0-2') + ')' : '' }}
                                </span>
                            </td>
                            <td *ngIf="data.saleView">{{ discount.sales?.price ? (discount.sales?.price - discount.sales?.value | currency: data.currency) : '' }}</td>
                            <td *ngIf="data.purchaseView">
                                {{ discount.buy?.price | currency: buyPosition?.priceCurrency }}
                            </td>
                            <td *ngIf="data.purchaseView">
                                {{ discount.buy?.value | currency: buyPosition?.priceCurrency }} {{ discount.buy?.discount ? '(' + (discount.buy?.discount / 100  | percent: '1.0-2') + ')' : '' }}
                            </td>
                            <td *ngIf="data.purchaseView">
                                {{ discount.buy?.price ? (discount.buy?.price - discount.buy?.value | currency: buyPosition?.priceCurrency) : '' }}
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="position.type === 'additional'">
                        <td class="row-header">{{ position.name }}</td>
                        <td *ngIf="data.saleView">
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                *ngIf="data.isEditable"
                                [ngModel]="position?.priceBeforeDiscountsValue"
                                (ngModelChange)="changePositionPrice($event)"
                                [ngModelOptions]="{updateOn: 'blur'}"
                                inputmode="decimal"
                            >
                            <span *ngIf="data.isEditable">{{ currencySymbol }}</span>
                            <span *ngIf="!data.isEditable">
                                {{ position.priceBeforeDiscountsValue | currency: data.currency }}
                            </span>
                        </td>
                        <td *ngIf="data.saleView">
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                *ngIf="data.isEditable"
                                [ngModel]="discounts[0].sales?.value"
                                (ngModelChange)="changeDiscount(discounts[0].sales, 'value', $event)"
                                [ngModelOptions]="{updateOn: 'blur'}"
                            >
                            <span *ngIf="data.isEditable">{{ currencySymbol }}</span>
                            <input
                                type="number"
                                step="0.01"
                                min="0"
                                *ngIf="data.isEditable"
                                [ngModel]="discounts[0].sales?.discount"
                                (ngModelChange)="changeDiscount(discounts[0].sales, 'percent', $event)"
                                [ngModelOptions]="{updateOn: 'blur'}"
                                inputmode="decimal"
                            >
                            <span *ngIf="data.isEditable">%</span>
                            <span *ngIf="!data.isEditable">
                                {{ discounts[0].sales?.value | currency: data.currency }} {{ discounts[0].sales?.discount ? '(' + (discounts[0].sales?.discount / 100  | percent: '1.0-2') + ')' : '' }}
                            </span>
                        </td>
                        <td *ngIf="data.saleView">{{ position.priceAfterDiscountsValue | currency: data.currency }}</td>
                    </tr>
                    <tr *ngIf="!data.isGross" class="total">
                        <td class="row-header">{{ 'SALES_DOCUMENT|Razem netto' | translate }}</td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView"><span *ngIf="!position.priceIsGross">{{ position.priceAfterDiscountsValue | currency: data.currency }}</span></td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView">
                            {{ convertToNetBuyPrice(buyPosition?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }}
                        </td>
                    </tr>
                    <tr>
                        <td class="row-header">{{ 'SALES_DOCUMENT|Stawka VAT' | translate }}</td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView">
                            <select [ngModel]="position?.priceTaxRateId"
                                (ngModelChange)="changePositionTaxRate($event)"
                                *ngIf="data.salesDocument.isCustomTaxRatesMode && (!data.salesDocument.isOneTaxRateMode || position.type === 'additional') && data.isEditable"
                                >
                                <option *ngFor="let rate of data.taxRates" [ngValue]="rate.id">{{ rate.name }}</option>
                            </select>
                            <span *ngIf="data.salesDocument.taxRateCalculationMethod === 'netPosition'">
                                {{ taxValue(position?.priceTaxRate, position?.priceAfterDiscountsValue) | currency: data.currency }}
                            </span>

                            <span *ngIf="(data.salesDocument.isOneTaxRateMode && position.type !== 'additional') || !data.isEditable || !data.salesDocument.isCustomTaxRatesMode">
                                {{ position?.priceTaxRate / 100 | percent }}
                            </span>
                        </td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView">
                            <span>{{ buyPosition?.priceTaxRate / 100 | percent }}</span>
                            <span *ngIf="data.salesDocument.taxRateCalculationMethod === 'netPosition'">
                                {{ taxValue(position?.priceTaxRate, position?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }}
                            </span>
                        </td>
                    </tr>
                    <tr *ngIf="data.salesDocument.taxRateCalculationMethod === 'netPosition'" class="total">
                        <td class="row-header">{{ 'SALES_DOCUMENT|Razem brutto' | translate }}</td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView">{{ position.priceAfterDiscountsValue + taxValue(position?.priceTaxRate, position?.priceAfterDiscountsValue) | currency: data.currency }}</td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView">
                            {{ buyPosition?.priceAfterDiscountsValue + taxValue(buyPosition?.priceTaxRate, buyPosition?.priceAfterDiscountsValue) | currency: buyPosition?.priceCurrency }}
                        </td>
                    </tr>
                    <tr *ngIf="data.salesDocument.taxRateCalculationMethod === 'grossSummary'" class="total">
                        <td class="row-header">{{ 'SALES_DOCUMENT|Razem brutto' | translate }}</td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView"></td>
                        <td *ngIf="data.saleView">{{ position.priceAfterDiscountsValue | currency: data.currency }}</td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView"></td>
                        <td *ngIf="data.purchaseView">
                            {{ buyPosition?.priceAfterDiscountsValue | currency: buyPosition?.priceCurrency }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div
    class="curtain"
    (click)="close()"
></div>

